/**
 * Consulta la verificación de la CIEC tras el envío y devuelve lo que debe ver el cliente.
 *
 * - Sin verificación pedida (el servidor no pudo publicar sat-verify): "continues" desde el principio.
 * - Con verificación: "checking" mientras se consulta (cada 3 s, 90 s como mucho) y luego el resultado.
 */

import * as React from "react";
import {
  fetchVerificationStatus,
  pollVerification,
  type VerificationView,
} from "./verification";

const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

export function useVerificationStatus(
  sessionId: string | null,
  verificationRequested: boolean
): VerificationView {
  const [view, setView] = React.useState<VerificationView>("checking");

  React.useEffect(() => {
    if (!sessionId || !verificationRequested) return;

    let cancelled = false;
    pollVerification(() => fetchVerificationStatus(sessionId), {
      now: Date.now,
      sleep,
      isCancelled: () => cancelled,
    }).then((outcome) => {
      if (!cancelled) setView(outcome);
    });

    return () => {
      cancelled = true;
    };
  }, [sessionId, verificationRequested]);

  return sessionId && verificationRequested ? view : "continues";
}
